module.exports = __webpack_public_path__ + "img/financialAdsiorPic.a1a7ed81.png";